"use client";

import _defineProperty from "/data/jenkins/workspace/PROD-web-cxm-admin-web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/defineProperty";
import { unit } from '@ant-design/cssinjs';
import { resetComponent, resetIcon, textEllipsis } from '../../style';
import { genCompactItemStyle } from '../../style/compact-item';
import { genStyleHooks, mergeToken } from '../../theme/internal';
import genDropdownStyle from './dropdown';
import genMultipleStyle from './multiple';
import genSingleStyle from './single'; // ============================= Selector =============================

var genSelectorStyle = function genSelectorStyle(token) {
  var _$concat, _ref2;

  var componentCls = token.componentCls,
      selectorBg = token.selectorBg;
  return _ref2 = {
    position: 'relative',
    backgroundColor: selectorBg,
    border: "".concat(unit(token.lineWidth), " ").concat(token.lineType, " ").concat(token.colorBorder),
    transition: "all ".concat(token.motionDurationMid, " ").concat(token.motionEaseInOut),
    input: {
      cursor: 'pointer'
    }
  }, _defineProperty(_ref2, "".concat(componentCls, "-show-search&"), {
    cursor: 'text',
    input: {
      cursor: 'auto',
      color: 'inherit',
      height: '100%'
    }
  }), _defineProperty(_ref2, "".concat(componentCls, "-disabled&"), (_$concat = {
    color: token.colorTextDisabled,
    background: token.colorBgContainerDisabled,
    cursor: 'not-allowed'
  }, _defineProperty(_$concat, "".concat(componentCls, "-multiple&"), {
    background: token.multipleSelectorBgDisabled
  }), _defineProperty(_$concat, "input", {
    cursor: 'not-allowed'
  }), _$concat)), _ref2;
}; // ============================== Status ==============================


var genStatusStyle = function genStatusStyle(rootSelectCls, token) {
  var _Object$assign;

  var overwriteDefaultBorder = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
  var componentCls = token.componentCls,
      borderHoverColor = token.borderHoverColor,
      antCls = token.antCls,
      borderActiveColor = token.borderActiveColor,
      outlineColor = token.outlineColor,
      controlOutlineWidth = token.controlOutlineWidth;
  var overwriteStyle = overwriteDefaultBorder ? _defineProperty({}, "".concat(componentCls, "-selector"), {
    borderColor: borderActiveColor
  }) : {};
  return _defineProperty({}, rootSelectCls, _defineProperty({}, "&:not(".concat(componentCls, "-disabled):not(").concat(componentCls, "-customize-input):not(").concat(antCls, "-pagination-size-changer)"), Object.assign(Object.assign({}, overwriteStyle), (_Object$assign = {}, _defineProperty(_Object$assign, "&:hover ".concat(componentCls, "-selector"), {
    borderColor: borderHoverColor
  }), _defineProperty(_Object$assign, "".concat(componentCls, "-focused& ").concat(componentCls, "-selector"), {
    borderColor: borderActiveColor,
    boxShadow: "0 0 0 ".concat(unit(controlOutlineWidth), " ").concat(outlineColor),
    outline: 0
  }), _Object$assign))));
}; // ============================== Styles ==============================
// /* Reset search input style */


var getSearchInputWithoutBorderStyle = function getSearchInputWithoutBorderStyle(token) {
  var componentCls = token.componentCls;
  return _defineProperty({}, "".concat(componentCls, "-selection-search-input"), {
    margin: 0,
    padding: 0,
    background: 'transparent',
    border: 'none',
    outline: 'none',
    appearance: 'none',
    fontFamily: 'inherit',
    '&::-webkit-search-cancel-button': {
      display: 'none',
      '-webkit-appearance': 'none'
    }
  });
}; // =============================== Base ===============================


var genBaseStyle = function genBaseStyle(token) {
  var _Object$assign3, _Object$assign4, _ref6;

  var antCls = token.antCls,
      componentCls = token.componentCls,
      inputPaddingHorizontalBase = token.inputPaddingHorizontalBase,
      iconCls = token.iconCls;
  return _ref6 = {}, _defineProperty(_ref6, componentCls, Object.assign(Object.assign({}, resetComponent(token)), (_Object$assign4 = {
    position: 'relative',
    display: 'inline-block',
    cursor: 'pointer'
  }, _defineProperty(_Object$assign4, "&:not(".concat(componentCls, "-customize-input) ").concat(componentCls, "-selector"), Object.assign(Object.assign({}, genSelectorStyle(token)), getSearchInputWithoutBorderStyle(token))), _defineProperty(_Object$assign4, "".concat(componentCls, "-selection-item"), Object.assign(Object.assign({
    flex: 1,
    fontWeight: 'normal',
    position: 'relative',
    userSelect: 'none'
  }, textEllipsis), _defineProperty({}, "> ".concat(antCls, "-typography"), {
    display: 'inline'
  }))), _defineProperty(_Object$assign4, "".concat(componentCls, "-selection-placeholder"), Object.assign(Object.assign({}, textEllipsis), {
    flex: 1,
    color: token.colorTextPlaceholder,
    pointerEvents: 'none'
  })), _defineProperty(_Object$assign4, "".concat(componentCls, "-arrow"), Object.assign(Object.assign({}, resetIcon()), (_Object$assign3 = {
    position: 'absolute',
    top: '50%',
    insetInlineStart: 'auto',
    insetInlineEnd: inputPaddingHorizontalBase,
    height: token.fontSizeIcon,
    marginTop: token.calc(token.fontSizeIcon).mul(-1).div(2).equal(),
    color: token.colorTextQuaternary,
    fontSize: token.fontSizeIcon,
    lineHeight: 1,
    textAlign: 'center',
    pointerEvents: 'none',
    display: 'flex',
    alignItems: 'center'
  }, _defineProperty(_Object$assign3, iconCls, _defineProperty({
    verticalAlign: 'top',
    transition: "transform ".concat(token.motionDurationSlow),
    '> svg': {
      verticalAlign: 'top'
    }
  }, "&:not(".concat(componentCls, "-suffix)"), {
    pointerEvents: 'auto'
  })), _defineProperty(_Object$assign3, "".concat(componentCls, "-disabled &"), {
    cursor: 'not-allowed'
  }), _defineProperty(_Object$assign3, '> *:not(:last-child)', {
    marginInlineEnd: 8 // FIXME: magic

  }), _Object$assign3))), _defineProperty(_Object$assign4, "".concat(componentCls, "-clear"), {
    position: 'absolute',
    top: '50%',
    insetInlineStart: 'auto',
    insetInlineEnd: inputPaddingHorizontalBase,
    zIndex: 1,
    display: 'inline-block',
    width: token.fontSizeIcon,
    height: token.fontSizeIcon,
    marginTop: token.calc(token.fontSizeIcon).mul(-1).div(2).equal(),
    color: token.colorTextQuaternary,
    fontSize: token.fontSizeIcon,
    fontStyle: 'normal',
    lineHeight: 1,
    textAlign: 'center',
    textTransform: 'none',
    background: token.clearBg,
    cursor: 'pointer',
    opacity: 0,
    transition: "color ".concat(token.motionDurationMid, " ease, opacity ").concat(token.motionDurationSlow, " ease"),
    textRendering: 'auto',
    '&:before': {
      display: 'block'
    },
    '&:hover': {
      color: token.colorTextTertiary
    }
  }), _defineProperty(_Object$assign4, '&:hover', _defineProperty({}, "".concat(componentCls, "-clear"), {
    opacity: 1
  })), _Object$assign4))), _defineProperty(_ref6, "".concat(componentCls, "-has-feedback"), _defineProperty({}, "".concat(componentCls, "-clear"), {
    insetInlineEnd: token.calc(inputPaddingHorizontalBase).add(token.fontSize).add(token.paddingXS).equal()
  })), _ref6;
}; // ============================== Styles ==============================


var genSelectStyle = function genSelectStyle(token) {
  var _componentCls;

  var componentCls = token.componentCls;
  return [_defineProperty({}, componentCls, (_componentCls = {}, _defineProperty(_componentCls, "&-borderless ".concat(componentCls, "-selector"), {
    backgroundColor: "transparent !important",
    borderColor: "transparent !important",
    boxShadow: "none !important"
  }), _defineProperty(_componentCls, "&".concat(componentCls, "-in-form-item"), {
    width: '100%'
  }), _componentCls)), // =====================================================
  // ==                       LTR                       ==
  // =====================================================
  // Base
  genBaseStyle(token), // Single
  genSingleStyle(token), // Multiple
  genMultipleStyle(token), // Dropdown
  genDropdownStyle(token), // =====================================================
  // ==                       RTL                       ==
  // =====================================================
  _defineProperty({}, "".concat(componentCls, "-rtl"), {
    direction: 'rtl'
  }), // =====================================================
  // ==                     Status                      ==
  // =====================================================
  genStatusStyle(componentCls, mergeToken(token, {
    borderHoverColor: token.colorPrimaryHover,
    borderActiveColor: token.colorPrimary,
    outlineColor: token.controlOutline
  })), genStatusStyle("".concat(componentCls, "-status-error"), mergeToken(token, {
    borderHoverColor: token.colorErrorHover,
    borderActiveColor: token.colorError,
    outlineColor: token.colorErrorOutline
  }), true), genStatusStyle("".concat(componentCls, "-status-warning"), mergeToken(token, {
    borderHoverColor: token.colorWarningHover,
    borderActiveColor: token.colorWarning,
    outlineColor: token.colorWarningOutline
  }), true), // =====================================================
  // ==             Space Compact                       ==
  // =====================================================
  genCompactItemStyle(token, {
    borderElCls: "".concat(componentCls, "-selector"),
    focusElCls: "".concat(componentCls, "-focused")
  })];
}; // ============================== Export ==============================


export var prepareComponentToken = function prepareComponentToken(token) {
  var fontSize = token.fontSize,
      lineHeight = token.lineHeight,
      controlHeight = token.controlHeight,
      controlPaddingHorizontal = token.controlPaddingHorizontal,
      zIndexPopupBase = token.zIndexPopupBase,
      colorText = token.colorText,
      fontWeightStrong = token.fontWeightStrong,
      controlItemBgActive = token.controlItemBgActive,
      controlItemBgHover = token.controlItemBgHover,
      colorBgContainer = token.colorBgContainer,
      colorFillSecondary = token.colorFillSecondary,
      controlHeightLG = token.controlHeightLG,
      controlHeightSM = token.controlHeightSM,
      colorBgContainerDisabled = token.colorBgContainerDisabled,
      colorTextDisabled = token.colorTextDisabled;
  return {
    zIndexPopup: zIndexPopupBase + 50,
    optionSelectedColor: colorText,
    optionSelectedFontWeight: fontWeightStrong,
    optionSelectedBg: controlItemBgActive,
    optionActiveBg: controlItemBgHover,
    optionPadding: "".concat((controlHeight - fontSize * lineHeight) / 2, "px ").concat(controlPaddingHorizontal, "px"),
    optionFontSize: fontSize,
    optionLineHeight: lineHeight,
    optionHeight: controlHeight,
    selectorBg: colorBgContainer,
    clearBg: colorBgContainer,
    singleItemHeightLG: controlHeightLG,
    multipleItemBg: colorFillSecondary,
    multipleItemBorderColor: 'transparent',
    multipleItemHeight: controlHeightSM,
    multipleItemHeightLG: controlHeight,
    multipleSelectorBgDisabled: colorBgContainerDisabled,
    multipleItemColorDisabled: colorTextDisabled,
    multipleItemBorderColorDisabled: 'transparent',
    showArrowPaddingInlineEnd: Math.ceil(token.fontSize * 1.25)
  };
};
export default genStyleHooks('Select', function (token, _ref) {
  var rootPrefixCls = _ref.rootPrefixCls;
  var selectToken = mergeToken(token, {
    rootPrefixCls: rootPrefixCls,
    inputPaddingHorizontalBase: token.calc(token.paddingSM).sub(1).equal(),
    multipleSelectItemHeight: token.multipleItemHeight,
    selectHeight: token.controlHeight
  });
  return [genSelectStyle(selectToken)];
}, prepareComponentToken, {
  unitless: {
    optionLineHeight: true,
    optionSelectedFontWeight: true
  }
});